
<div class="right-side p-5">
  <h2>Invitation for Expression of Interest (EOI)</h2>
  <div class="section">
    <form [formGroup]="formEOI">
      <h5 class="mt-4">1. Enterprise Details </h5>
      <div class="row">
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>EOI Response Number</mat-label>
            <input matInput
                   type="text"
                   formControlName="EnterpriseCode"
                   placeholder="Enter enterprise code">
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Udyam Registration Number</mat-label>
            <input matInput
                   type="text"
                   formControlName="UdyamRegistrationNumber"
                   placeholder="Enter udyam registration number">
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Name of Authorised Person</mat-label>
            <input matInput
                   type="text"
                   formControlName="EnterpriseName"
                   placeholder="Enter name of authorised person">
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Mobile Number</mat-label>
            <input matInput
                   type="text"
                   formControlName="MobileNumber"
                   placeholder="Enter mobile number">
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Email ID</mat-label>
            <input matInput
                   type="text"
                   formControlName="EmailID"
                   placeholder="Enter email id">
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Date of Establishment</mat-label>
            <input matInput
                   type="text"
                   formControlName="DateOfEstablishment"
                   placeholder="Enter date of establishment">
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Present Address of Enterprise</mat-label>
            <input matInput
                   type="text"
                   formControlName="PresentAddress"
                   placeholder="Enter present address">
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Area of Current Space</mat-label>
            <input matInput
                   type="text"
                   formControlName="AreaOfCurrentSpace"
                   placeholder="Enter current space location">
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Current Rent Paid</mat-label>
            <input matInput
                   type="text"
                   formControlName="CurrentRentPaid"
                   placeholder="Enter current rent paid">
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rent Frequency</mat-label>
            <input matInput
                   type="text"
                   formControlName="RentFrequency"
                   placeholder="Enter rent frequency">
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Number of Employees</mat-label>
            <input matInput
                   type="text"
                   formControlName="NumberOfEmployees"
                   placeholder="Enter number of employees">
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>District</mat-label>
            <input matInput
                   type="text"
                   formControlName="District"
                   placeholder="Enter district">
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Gender</mat-label>
            <input matInput
                   type="text"
                   formControlName="Gender"
                   placeholder="Enter gender">
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>SocialCategory</mat-label>
            <input matInput
                   type="text"
                   formControlName="SocialCategory"
                   placeholder="Enter social category">
          </mat-form-field>
        </div>        
      </div>
      <div class="row">
        <div class="col-lg-3 d-flex align-items-center">
          <mat-label class="me-2">Rent Agreement</mat-label>
          <button mat-raised-button
                  color="primary"
                  *ngIf="formEOI.get('RentAgreementPath')?.value"
                  (click)="openFilePreviewDialog(
  formEOI.get('RentAgreementPath')?.value,
  formEOI.get('RentAgreementName')?.value
)">
            View File
          </button>
        </div>
        <div class="col-lg-3 d-flex align-items-center">
          <mat-label class="me-2">Last Two Rent Payment Receipts</mat-label>
          <button mat-raised-button
                  color="primary"
                  *ngIf="formEOI.get('UploadLastTwoRentPaymentReceiptsPath')?.value"
                  (click)="openFilePreviewDialog(
  formEOI.get('UploadLastTwoRentPaymentReceiptsPath')?.value,
  formEOI.get('UploadLastTwoRentPaymentReceiptsName')?.value
)">
            View File
          </button>
        </div>
        <div class="col-lg-3 d-flex align-items-center">
          <mat-label class="me-2">Self Certification</mat-label>
          <button mat-raised-button
                  color="primary"
                  *ngIf="formEOI.get('SelfCertificationPath')?.value"
                  (click)="openFilePreviewDialog(
  formEOI.get('SelfCertificationPath')?.value,
  formEOI.get('SelfCertificationName')?.value
)">
            View File
          </button>
        </div>
      </div>
      <h5 class="mt-4">2. Product Details </h5>
      <div class="row">
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Sector</mat-label>
            <input matInput
                   type="text"
                   formControlName="Sector"
                   placeholder="Enter sector">
          </mat-form-field>
        </div>
        <!--<div class="col-lg-3">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>NIC Code</mat-label>
      <input matInput
             type="text"
             formControlName="NICCode"
             placeholder="Enter niccode">
    </mat-form-field>
  </div>-->

        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>NIC Code</mat-label>
            <textarea matInput
                      formControlName="NICCode"
                      placeholder="Enter NIC Code(s)"
                      cdkTextareaAutosize
                      cdkAutosizeMinRows="1"
                      cdkAutosizeMaxRows="3"></textarea>
          </mat-form-field>
        </div>

        <div class="col-lg-3 d-flex align-items-center">
          <mat-label class="me-2">Present Product</mat-label>
          <button mat-raised-button
                  color="primary"
                  *ngIf="formEOI.get('PresentProductPath')?.value"
                  (click)="openFilePreviewDialog(
  formEOI.get('PresentProductPath')?.value,
  formEOI.get('PresentProductName')?.value
)">
            View File
          </button>
        </div>
      </div>
      <h5 class="mt-4">3. Legal Information </h5>
      <div class="row">
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>PanCardNumber</mat-label>
            <input matInput
                   type="text"
                   formControlName="PanCardNumber"
                   placeholder="Enter pan card number">
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>GST Registration No</mat-label>
            <input matInput
                   type="text"
                   formControlName="GSTRegistrationNumber"
                   placeholder="Enter gst registration number">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 d-flex align-items-center">
          <mat-label class="me-2">Udyam Certificate </mat-label>
          <button mat-raised-button
                  color="primary"
                  *ngIf="formEOI.get('UdyamCertificatePath')?.value"
                  (click)="openFilePreviewDialog(
  formEOI.get('UdyamCertificatePath')?.value,
  formEOI.get('UdyamCertificateName')?.value
)">
            View File
          </button>
        </div>

        <div class="col-lg-3 d-flex align-items-center">
          <mat-label class="me-2">PAN Card </mat-label>
          <button mat-raised-button
                  color="primary"
                  *ngIf="formEOI.get('PanCardNumberPath')?.value"
                  (click)="openFilePreviewDialog(
  formEOI.get('PanCardNumberPath')?.value,
  formEOI.get('PanCardNumberName')?.value
)">
            View File
          </button>
        </div>

        <div class="col-lg-3 d-flex align-items-center">
          <mat-label class="me-2">GST Registration Certificate</mat-label>
          <button mat-raised-button
                  color="primary"
                  *ngIf="formEOI.get('GSTRegistrationCertificatePath')?.value"
                  (click)="openFilePreviewDialog(
  formEOI.get('GSTRegistrationCertificatePath')?.value,
  formEOI.get('GSTRegistrationCertificateName')?.value
)">
            View File
          </button>
        </div>
        <div class="col-lg-3 d-flex align-items-center">
          <mat-label class="me-2">CPCB Category</mat-label>
          <button mat-raised-button
                  color="primary"
                  *ngIf="formEOI.get('CPCBPath')?.value"
                  (click)="openFilePreviewDialog(
  formEOI.get('CPCBPath')?.value,
  formEOI.get('CPCBName')?.value
)">
            View File
          </button>
        </div>
      </div>
      <h5 class="mt-4">4. Financial Year - Turnover and Net Worth (INR crore) </h5>
      <div class="row">
        <div class="table-responsive">
          <table mat-table [dataSource]="dataSource" matSort class="table table-striped table-bordered table-hover" matTableResponsive
                 matSortActive="starRating" matSortDirection="desc" matSortDisableClear>
            <ng-container matColumnDef="Fin_Year">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Fin_Year</th>
              <td mat-cell *matCellDef="let el">Turnover</td>


            </ng-container>
            <!-- 2020-21 -->
            <ng-container matColumnDef="TurnoverFY2020_21">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>TurnoverFY2020_21</th>
              <td mat-cell *matCellDef="let el">
                {{ el.TurnoverFY2020_21 }} |
                <ng-container *ngIf="el.FY2020_21_Path; else noFile2020">
                  <button mat-raised-button color="primary"
                          (click)="openFilePreviewDialog(el.FY2020_21_Path, el.FY2020_21_Name)">
                    View File
                  </button>
                </ng-container>
                <ng-template #noFile2020>
                  <span class="text-muted">No file</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- 2021-22 -->
            <ng-container matColumnDef="TurnoverFY2021_22">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>TurnoverFY2021_22</th>
              <td mat-cell *matCellDef="let el">
                {{ el.TurnoverFY2021_22 }} |
                <ng-container *ngIf="el.FY2021_22_Path; else noFile2021">
                  <button mat-raised-button color="primary"
                          (click)="openFilePreviewDialog(el.FY2021_22_Path, el.FY2021_22_Name)">
                    View File
                  </button>
                </ng-container>
                <ng-template #noFile2021>
                  <span class="text-muted">No file</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- 2022-23 -->
            <ng-container matColumnDef="TurnoverFY2022_23">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>TurnoverFY2022_23</th>
              <td mat-cell *matCellDef="let el">
                {{ el.TurnoverFY2022_23 }} |
                <ng-container *ngIf="el.FY2022_23_Path; else noFile2022">
                  <button mat-raised-button color="primary"
                          (click)="openFilePreviewDialog(el.FY2022_23_Path, el.FY2022_23_Name)">
                    View File
                  </button>
                </ng-container>
                <ng-template #noFile2022>
                  <span class="text-muted">No file</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- 2023-24 -->
            <ng-container matColumnDef="TurnoverFY2023_24">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>TurnoverFY2023_24</th>
              <td mat-cell *matCellDef="let el">
                {{ el.TurnoverFY2023_24 }} |
                <ng-container *ngIf="el.FY2023_24_Path; else noFile2023">
                  <button mat-raised-button color="primary"
                          (click)="openFilePreviewDialog(el.FY2023_24_Path, el.FY2023_24_Name)">
                    View File
                  </button>
                </ng-container>
                <ng-template #noFile2023>
                  <span class="text-muted">No file</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- 2024-25 -->
            <ng-container matColumnDef="TurnoverFY2024_25">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>TurnoverFY2024_25</th>
              <td mat-cell *matCellDef="let el">
                {{ el.TurnoverFY2024_25 }} |
                <ng-container *ngIf="el.FY2024_25_Path; else noFile2024">
                  <button mat-raised-button color="primary"
                          (click)="openFilePreviewDialog(el.FY2024_25_Path, el.FY2024_25_Name)">
                    View File
                  </button>
                </ng-container>
                <ng-template #noFile2024>
                  <span class="text-muted">No file</span>
                </ng-template>
              </td>
            </ng-container>



            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            Row shown when there is no matching data.
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">No data matching the filter</td>
            </tr>
          </table>
        </div>
      </div>
    </form>
    <div class="row">
      <div class="col-md-4">
        <button class="btn btn-info" (click)="back()">Back</button>
      </div>
    </div>
  </div>
</div>

